// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as React$1 from "motion/react";
import * as TailwindMerge from "tailwind-merge";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as Client_assets from "@literacyplanet/client_assets";
import * as Motion$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Motion.res.mjs";
import * as AcademyIcons$LiteracyplanetClientSxEntry from "./AcademyIcons.res.mjs";
import * as AcademyAssets$LiteracyplanetClientSxEntry from "./AcademyAssets.res.mjs";
import * as WordFlyersTrophies$LiteracyplanetClientSxEntry from "../word_flyers/assets/WordFlyersTrophies.res.mjs";
import * as AcademyParallaxTypes$LiteracyplanetClientSxEntry from "./AcademyParallaxTypes.res.mjs";

var scroll = (function(el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

function AcademyParallaxUi$ScreenWindow(props) {
  var __navigateToWindow = props.navigateToWindow;
  var i = props.i;
  var navigateToWindow = __navigateToWindow !== undefined ? __navigateToWindow : false;
  var domRef = React.useRef(null);
  var isInView = React$1.useInView(domRef, {
        amount: 0.9
      });
  var match = AcademyParallaxTypes$LiteracyplanetClientSxEntry.use();
  var onActiveCategoryWindowChanged = match.onActiveCategoryWindowChanged;
  React.useEffect((function () {
          if (isInView) {
            onActiveCategoryWindowChanged(i);
          }
          
        }), [isInView]);
  React.useEffect((function () {
          if (navigateToWindow) {
            scroll(domRef.current);
          }
          
        }), [navigateToWindow]);
  return React.createElement("div", {
              key: String(i),
              ref: Caml_option.some(domRef),
              className: "academy__parallax__screen__window academy__parallax__screen__window-" + String(i)
            }, React.createElement("div", {
                  className: TailwindMerge.twMerge("academy__parallax__screen__window__page", isInView ? "academy__parallax__screen__window__page-active" : "")
                }, props.children));
}

var ScreenWindow = {
  make: AcademyParallaxUi$ScreenWindow
};

function AcademyParallaxUi$Levels(props) {
  var match = AcademyParallaxTypes$LiteracyplanetClientSxEntry.use();
  var onClickLevel = match.onClickLevel;
  var currentLevel = match.currentLevel;
  return React.createElement("aside", {
              className: "academy__levels"
            }, React.createElement("div", {
                  className: "academy__levels__panel"
                }, React.createElement("div", {
                      className: "academy__levels__house"
                    }, React.createElement("img", {
                          className: "academy__levels__house__image",
                          alt: "Academy",
                          src: AcademyAssets$LiteracyplanetClientSxEntry.academyHouseSvg
                        })), React.createElement("ul", {
                      className: "academy__levels__rail"
                    }, Belt_Array.map(match.query.levels, (function (param) {
                            var levelName = param[1];
                            var level = param[0];
                            var isActive = currentLevel === level;
                            return React.createElement("li", {
                                        key: levelName,
                                        className: TailwindMerge.twMerge("academy__levels__item", isActive ? "academy__levels__item--active" : "")
                                      }, React.createElement("button", {
                                            className: "academy__levels__item__button",
                                            onClick: (function (param) {
                                                onClickLevel(level);
                                              })
                                          }, React.createElement("span", {
                                                className: "academy__levels__item__label"
                                              }, levelName)));
                          })))));
}

var Levels = {
  make: AcademyParallaxUi$Levels
};

function renderNull(v, f) {
  return Belt_Option.mapWithDefault(v, null, f);
}

function AcademyParallaxUi$StarRating(props) {
  var filledCount;
  switch (props.trophy) {
    case "Glass" :
        filledCount = 0;
        break;
    case "Bronze" :
        filledCount = 1;
        break;
    case "Silver" :
        filledCount = 2;
        break;
    case "Gold" :
        filledCount = 3;
        break;
    
  }
  return React.createElement("div", {
              className: "academy__star-rating"
            }, Belt_Array.map([
                  1,
                  2,
                  3
                ], (function (i) {
                    return React.createElement("img", {
                                key: String(i),
                                className: "academy__star-rating__star",
                                alt: "",
                                src: i <= filledCount ? AcademyAssets$LiteracyplanetClientSxEntry.starFilledSvg : AcademyAssets$LiteracyplanetClientSxEntry.starUnfilledSvg
                              });
                  })));
}

var StarRating = {
  make: AcademyParallaxUi$StarRating
};

function isSeniorLevel(level) {
  if (level === "LEVEL_9" || level === "LEVEL_8" || level === "LEVEL_7" || level === "LEVEL_6" || level === "LEVEL_5" || level === "LEVEL_4" || level === "LEVEL_12" || level === "LEVEL_11") {
    return true;
  } else {
    return level === "LEVEL_10";
  }
}

function AcademyParallaxUi$RenderData(props) {
  var data = props.data;
  var i = props.i;
  var match = AcademyParallaxTypes$LiteracyplanetClientSxEntry.use();
  var onClickActivity = match.onClickActivity;
  var onClickCategory = match.onClickCategory;
  var onGetMatrixActivity = match.onGetMatrixActivity;
  var onGetMatrix = match.onGetMatrix;
  var strand = match.strand;
  var query = match.query;
  var useSeniorIcons = isSeniorLevel(match.currentLevel);
  var cardCount;
  if (typeof data !== "object") {
    cardCount = 0;
  } else {
    switch (data.TAG) {
      case "Strands" :
      case "Categories" :
          cardCount = data._0.length;
          break;
      case "Activities" :
          cardCount = 0;
          break;
      
    }
  }
  var tmp;
  var exit = 0;
  if (typeof data !== "object") {
    tmp = null;
  } else {
    switch (data.TAG) {
      case "Strands" :
      case "Categories" :
          exit = 1;
          break;
      case "Activities" :
          tmp = Belt_Array.map(data._0, (function (activity) {
                  var agg = onGetMatrixActivity(activity.id);
                  if (typeof agg !== "object") {
                    return null;
                  }
                  var agg$1 = agg._0;
                  var isCompleted = agg$1.progressState === "Finished";
                  var icon = Js_dict.get(AcademyAssets$LiteracyplanetClientSxEntry.gameIconByTitle, activity.title);
                  var tmp;
                  if (icon !== undefined) {
                    tmp = icon;
                  } else {
                    var match = agg$1.contentKind;
                    var match$1 = agg$1.kind;
                    if (match === "word_list") {
                      tmp = match$1 === "spell_test" ? AcademyAssets$LiteracyplanetClientSxEntry.spellTestActivityIcon : Client_assets.primaryActivityIcons.getIcon(agg$1.kind);
                    } else if (match === "tupperware" && strand !== undefined) {
                      switch (strand.title) {
                        case "Comprehension" :
                            tmp = AcademyAssets$LiteracyplanetClientSxEntry.comprehensionActivityIcon;
                            break;
                        case "Grammar" :
                            tmp = AcademyAssets$LiteracyplanetClientSxEntry.grammarActivityIcon;
                            break;
                        case "Spelling" :
                            tmp = AcademyAssets$LiteracyplanetClientSxEntry.spellingLessonActivityIcon;
                            break;
                        default:
                          tmp = Client_assets.primaryActivityIcons.getIcon(agg$1.kind);
                      }
                    } else {
                      tmp = Client_assets.primaryActivityIcons.getIcon(agg$1.kind);
                    }
                  }
                  var match$2 = agg$1.latestAttempt;
                  return JsxPPXReactSupportU.createElementVariadicWithKey(activity.id, Motion$LiteracyplanetClientFlags.Button.make, {
                              whileTap: {
                                scale: 0.95
                              },
                              whileHover: {
                                scale: 1.05
                              },
                              className: "academy__activity__card",
                              onClick: (function (param) {
                                  onClickActivity(activity);
                                }),
                              children: null
                            }, [
                              isCompleted ? React.createElement("span", {
                                      "aria-hidden": true,
                                      className: "academy__activity__card__check-badge"
                                    }, "✓") : null,
                              React.createElement("h2", {
                                    className: "academy__activity__card__title"
                                  }, activity.title),
                              React.createElement("div", {
                                    className: "academy__activity__card__game__icon"
                                  }, React.createElement(AcademyIcons$LiteracyplanetClientSxEntry.ProgressImageIcon.make, {
                                        imageUrl: tmp,
                                        className: "academy__activity__card__game__icon__image",
                                        progressState: agg$1.progressState
                                      })),
                              React.createElement("div", {
                                    className: "academy__activity__card__actions"
                                  }, React.createElement("button", {
                                        className: "academy__activity__card__play"
                                      }, React.createElement(AcademyIcons$LiteracyplanetClientSxEntry.PlayButton.make, {
                                            className: "academy__activity__card__play-icon"
                                          })), match$2 !== undefined ? React.createElement(React.Fragment, {}, React.createElement("div", {
                                              className: "academy__activity__card__accuracy"
                                            }, String(match$2.accuracy) + "%"), React.createElement("div", {
                                              className: "academy__activity__card__trophy"
                                            }, WordFlyersTrophies$LiteracyplanetClientSxEntry.trophyToIcon(match$2.trophy))) : null)
                            ]);
                }));
          break;
      
    }
  }
  if (exit === 1) {
    tmp = Belt_Array.map(data._0, (function (category) {
            var matrix = onGetMatrix(category.id);
            var strandIcon;
            var exit = 0;
            if (strand !== undefined && strand.title === "Comprehension") {
              strandIcon = Js_dict.get(AcademyAssets$LiteracyplanetClientSxEntry.comprehensionIconByTitle, category.title);
            } else {
              exit = 1;
            }
            if (exit === 1) {
              strandIcon = useSeniorIcons ? Js_dict.get(AcademyAssets$LiteracyplanetClientSxEntry.seniorIconByTitle, category.title) : Js_dict.get(AcademyAssets$LiteracyplanetClientSxEntry.juniorIconByTitle, category.title);
            }
            var hasIcon = Belt_Option.isSome(strandIcon);
            var hasSubtitle = Belt_Option.isSome(category.subtitle);
            var shouldUseSmallTitleFont = hasIcon || useSeniorIcons;
            var isActive = Belt_Array.some(query.breadcrumb, (function (bc) {
                    return bc.id === category.id;
                  }));
            var isCompleted = Belt_Option.mapWithDefault(matrix.progress, false, (function (progress) {
                    return progress >= 100;
                  }));
            var subtitle = category.subtitle;
            return JsxPPXReactSupportU.createElementWithKey(category.id, Motion$LiteracyplanetClientFlags.Button.make, {
                        whileTap: {
                          scale: 0.95
                        },
                        whileHover: {
                          scale: 1.05
                        },
                        className: TailwindMerge.twMerge("academy__menu__card", hasIcon ? "academy__menu__card--with-icon" : "", hasSubtitle ? "" : "academy__menu__card--no-subtitle", isActive ? "academy__menu__card-active" : ""),
                        onClick: (function (param) {
                            onClickCategory(category, i);
                          }),
                        children: React.createElement(React.Fragment, {}, React.createElement("div", {
                                  className: "academy__menu__card__check-wrap"
                                }, isCompleted ? React.createElement("span", {
                                        "aria-hidden": true,
                                        className: "academy__menu__card__check-badge"
                                      }, "✓") : null), React.createElement("div", {
                                  className: "academy__menu__card__content"
                                }, subtitle !== undefined ? React.createElement(React.Fragment, {}, React.createElement("div", {
                                            className: "academy__menu__card__header"
                                          }, React.createElement("h3", {
                                                className: "academy__menu__card__title"
                                              }, category.title)), React.createElement("p", {
                                            className: "academy__menu__card__subtitle"
                                          }, subtitle)) : React.createElement("p", {
                                        className: TailwindMerge.twMerge(shouldUseSmallTitleFont ? "academy__menu__card__title" : "academy__menu__card__subtitle", hasIcon && !shouldUseSmallTitleFont ? "academy__menu__card__subtitle--with-icon" : ""),
                                        dangerouslySetInnerHTML: {
                                          __html: category.title.replace(/-/g, "&#8209;")
                                        }
                                      }), strandIcon !== undefined ? React.createElement("div", {
                                        className: "academy__menu__card__icon-wrap"
                                      }, React.createElement("img", {
                                            className: "academy__menu__card__icon",
                                            alt: category.title,
                                            src: strandIcon
                                          })) : null), React.createElement("div", {
                                  className: "academy__menu__card__progress-shell"
                                }, React.createElement("div", {
                                      className: "academy__menu__card__progress-track"
                                    }, Belt_Option.mapWithDefault(matrix.progress, null, (function (progress) {
                                            return React.createElement("div", {
                                                        className: "academy__menu__card__progress__bar",
                                                        style: {
                                                          width: String(progress) + "%"
                                                        }
                                                      });
                                          }))), React.createElement("div", {
                                      className: "academy__menu__card__trophy"
                                    }, Belt_Option.mapWithDefault(matrix.trophy, null, (function (trophy) {
                                            return React.createElement(AcademyParallaxUi$StarRating, {
                                                        trophy: trophy
                                                      });
                                          })))))
                      });
          }));
  }
  return React.createElement("div", {
              className: TailwindMerge.twMerge("academy__menu__grid", i === 0 ? "academy__menu__grid-first-window" : "", cardCount > 9 ? "academy__menu__grid--many" : "")
            }, tmp);
}

var RenderData = {
  make: AcademyParallaxUi$RenderData
};

function AcademyParallaxUi$Menu(props) {
  var match = AcademyParallaxTypes$LiteracyplanetClientSxEntry.use();
  var loadWindow = match.loadWindow;
  var tmp;
  tmp = typeof loadWindow !== "object" || loadWindow.TAG !== "LoadNewWindow" ? null : React.createElement(AcademyParallaxUi$ScreenWindow, {
          id: "",
          i: loadWindow._0,
          navigateToWindow: true,
          children: null
        });
  return React.createElement(React.Fragment, {}, Belt_Array.mapWithIndex(match.query.data, (function (i, data) {
                    if (typeof loadWindow === "object") {
                      switch (loadWindow.TAG) {
                        case "LoadNewWindow" :
                            break;
                        case "ReplaceExistingWindow" :
                            var replaceAt = loadWindow._0;
                            if (replaceAt === i) {
                              return React.createElement(AcademyParallaxUi$ScreenWindow, {
                                          id: "",
                                          i: i,
                                          navigateToWindow: true,
                                          children: null
                                        });
                            }
                            if (i > replaceAt) {
                              return null;
                            }
                            break;
                        case "NavigateToWindow" :
                            if (loadWindow._0 === i) {
                              return React.createElement(AcademyParallaxUi$ScreenWindow, {
                                          id: "",
                                          i: i,
                                          navigateToWindow: true,
                                          children: React.createElement(AcademyParallaxUi$RenderData, {
                                                i: i,
                                                data: data
                                              })
                                        });
                            }
                            break;
                        
                      }
                    }
                    return React.createElement(AcademyParallaxUi$ScreenWindow, {
                                id: "",
                                i: i,
                                children: React.createElement(AcademyParallaxUi$RenderData, {
                                      i: i,
                                      data: data
                                    })
                              });
                  })), tmp);
}

var Menu = {
  make: AcademyParallaxUi$Menu
};

function AcademyParallaxUi(props) {
  var onBack = props.onBack;
  var ref = React.useRef(null);
  var match = AcademyParallaxTypes$LiteracyplanetClientSxEntry.use();
  var onClickBreadcrumb = match.onClickBreadcrumb;
  var activeCategoryWindow = match.activeCategoryWindow;
  var background = match.background;
  var backgroundImageStyle;
  backgroundImageStyle = typeof background !== "object" ? (
      background === "LoadingBg" ? ({}) : ({
            backgroundImage: "url('https://assets.literacyplanet.com/storyverse/book_of_goings/locations/shabby_woods/full/shabby_hut.webp')"
          })
    ) : ({
        backgroundImage: "url('https://assets.literacyplanet.com/storyverse/book_of_goings/" + background._0 + "')"
      });
  return React.createElement("div", {
              className: "academy__parallax",
              style: backgroundImageStyle
            }, React.createElement("div", {
                  ref: Caml_option.some(ref),
                  className: "academy__parallax__screen"
                }, React.createElement(AcademyParallaxUi$Menu, {})), React.createElement("div", {
                  className: "academy__parallax__breadcrumb"
                }, React.createElement("div", {
                      className: "academy__parallax__breadcrumb_strands"
                    }, React.createElement("button", {
                          "aria-label": "Back",
                          className: "academy__parallax__breadcrumb_back",
                          type: "button",
                          onClick: (function (param) {
                              onBack();
                            })
                        }, React.createElement(AcademyIcons$LiteracyplanetClientSxEntry.ChevronLeft.make, {
                              className: "academy__parallax__breadcrumb_back__icon"
                            })), Belt_Array.mapWithIndex(match.query.breadcrumb, (function (i, bc) {
                            return React.createElement("div", {
                                        key: bc.id,
                                        className: TailwindMerge.twMerge("academy__parallax__breadcrumb_links", activeCategoryWindow === i ? "academy__parallax__breadcrumb_links-active" : "", activeCategoryWindow < i ? "academy__parallax__breadcrumb_links-dimmed" : ""),
                                        onClick: (function (param) {
                                            onClickBreadcrumb(i);
                                          })
                                      }, bc.title, React.createElement("span", {
                                            "aria-hidden": true
                                          }, React.createElement(AcademyIcons$LiteracyplanetClientSxEntry.DoubleChevronRight.make, {
                                                className: "academy__parallax__breadcrumb_links__icon"
                                              })));
                          })))), React.createElement(AcademyParallaxUi$Levels, {}));
}

var make = AcademyParallaxUi;

export {
  scroll ,
  ScreenWindow ,
  Levels ,
  renderNull ,
  StarRating ,
  isSeniorLevel ,
  RenderData ,
  Menu ,
  make ,
}
/* react Not a pure module */
